import { render } from "./ClientAlbums.vue?vue&type=template&id=37db8bcb&ts=true"
import script from "./ClientAlbums.vue?vue&type=script&lang=ts"
export * from "./ClientAlbums.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__